import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Assessment } from '@mui/icons-material';

// Shared frame for the Login / Request access / password screens (animated background, 2026-10 redesign).
const Blob = ({ size, top, left, right, bottom, color, delay = 0, dur = 14 }) => (
  <Box sx={{ position: 'absolute', width: size, height: size, top, left, right, bottom, borderRadius: '50%', background: `radial-gradient(circle, ${color}, transparent 68%)`, filter: 'blur(6px)', animation: `blobMove ${dur}s ease-in-out ${delay}s infinite`, pointerEvents: 'none' }} />
);

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <Box sx={{
      minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, position: 'relative', overflow: 'hidden',
      background: 'var(--auth-bg)', backgroundSize: '300% 300%', animation: 'gradientShift 18s ease infinite',
    }}>
      <Blob size={520} top={-160} left={-140} color="var(--auth-blob-1)" />
      <Blob size={460} bottom={-160} right={-120} color="var(--auth-blob-2)" dur={18} delay={1} />
      <Blob size={340} top="38%" right="12%" color="var(--auth-blob-3)" dur={16} delay={2} />
      <Box sx={{ position: 'absolute', width: 120, height: 120, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.12)', top: '14%', left: '14%', animation: 'floatY 7s ease-in-out infinite' }} />
      <Box sx={{ position: 'absolute', width: 70, height: 70, borderRadius: '30%', border: '2px solid rgba(255,255,255,0.12)', bottom: '16%', left: '24%', animation: 'floatY 6s ease-in-out infinite', animationDelay: '1.5s' }} />

      <Box sx={{ width: '100%', maxWidth: 440, position: 'relative', zIndex: 1 }}>
        <Box className="anim-fade-up" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'center', mb: 3 }}>
          <Box sx={{ width: 48, height: 48, borderRadius: 3, background: 'var(--g-brand)', backgroundSize: '200% 200%', animation: 'gradientShift 6s ease infinite, pulseRing 3s ease-out infinite', display: 'grid', placeItems: 'center' }}>
            <Assessment sx={{ color: '#fff' }} />
          </Box>
          <Box>
            <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: 26, letterSpacing: '-0.02em', lineHeight: 1.1 }}>SSAT Sizing</Typography>
            <Typography sx={{ color: 'var(--link-on-dark)', fontSize: 12 }}>SQL Server → Amazon RDS right-sizing</Typography>
          </Box>
        </Box>
        <Paper elevation={3} className="anim-pop" sx={{ p: { xs: 3, sm: 4 }, borderRadius: 4, backdropFilter: 'blur(14px)', bgcolor: 'rgba(255,255,255,0.97)', boxShadow: '0 24px 70px rgba(0,0,0,0.45)', animationDelay: '120ms' }}>
          <Typography variant="h5" sx={{ mb: subtitle ? 0.5 : 2.5, color: '#0f172a' }}>{title}</Typography>
          {subtitle && <Typography sx={{ mb: 2.5, color: '#475569' }}>{subtitle}</Typography>}
          {children}
        </Paper>
        {footer && <Box className="anim-fade-up" sx={{ textAlign: 'center', mt: 2.5, color: 'rgba(255,255,255,0.78)', fontSize: 14, animationDelay: '300ms' }}>{footer}</Box>}
      </Box>
    </Box>
  );
}
